import { z } from 'zod';

import { baseBusinessApplicant, businessDetails } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

export const updateBusinessDetailsSchema = z
  .object({
    step: z.literal(ApplicationStep.BusinessDetails),
    enterprise: businessDetails,
    applicant: baseBusinessApplicant.pick({
      type: true,
      firstName: true,
      middleName: true,
      lastName: true,
    }),
  })
  .and(baseApplicationStep);
